import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    strongAuthSidebarDescription:
      'Sensitive operations such as card activations require your passcode.',
    successMessage: 'This card is now activated!',
    title: 'Enter the "token" code on the back of the card to activate it.',
    tokenImageAltText: '9 digits token located at the back of the Shine card',
  },
  fr: {
    strongAuthSidebarDescription:
      'Les opérations sensibles comme les activations de cartes nécessitent votre code secret.',
    successMessage: 'Cette carte est maintenant activée\xA0!',
    title: `Saisissez le code "token" figurant au dos de la carte pour l‘activer`,
    tokenImageAltText:
      'Token à 9 chiffres se trouvant au dos de la carte Shine',
  },
} as const);

export default locales;
